import { createSlice } from '@reduxjs/toolkit';
interface handleBackBtn {
    prevState: string;
    nextState: string;
    routeType: string;
    prevInnerState: string;
    nextInnerState: string;
}
const initialState = {
    prevState: '',
    nextState: '',
    routeType: '',
    prevInnerState: '',
    nextInnerState: '',
};

export const prevStateSlice = createSlice({
    name: 'prevState',
    initialState,
    reducers: {
        getpervState: (state: handleBackBtn, action: any) => {
            state.prevState = action.payload.prevState;
        },
        getNextState: (state: handleBackBtn, action: any) => {
            state.nextState = action.payload.nextState;
        },

        changeRouteType: (state: handleBackBtn, action: any) => {
            state.routeType = action.payload.routeType;
        },
        getpervInnerState: (state: handleBackBtn, action: any) => {
            state.prevInnerState = action.payload.prevInnerState;
        },
        getNextInnerState: (state: handleBackBtn, action: any) => {
            state.nextInnerState = action.payload.nextInnerState;
        },
    },
});

export const { getpervState, getNextState, changeRouteType, getpervInnerState, getNextInnerState }: any = prevStateSlice.actions;

export default prevStateSlice.reducer;
